import { createEditor, EditorInstance } from './editor';

let editorInstance: EditorInstance | null = null;

function generateDocumentId(length: number = 21): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => chars[byte % chars.length]).join('');
}

function getDocumentId(): string {
  // Extract document ID from URL path
  const path = window.location.pathname;
  const match = path.match(/^\/([a-zA-Z0-9_-]+)$/);

  if (match) {
    return match[1];
  }

  // No valid document ID - generate one and redirect
  const newId = generateDocumentId();
  window.location.href = `/${newId}`;
  throw new Error('Redirecting to new document');
}

function init(): void {
  const container = document.getElementById('editor');
  if (!container) {
    console.error('Editor container not found');
    return;
  }

  const documentId = getDocumentId();
  console.log('Opening document:', documentId);

  // Check for locked URL parameter
  const params = new URLSearchParams(window.location.search);
  const locked = params.has('locked');

  editorInstance = createEditor(container, documentId, { locked });

  // Update page title with document ID
  document.title = `Kafka - ${documentId}`;
}

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  if (editorInstance) {
    editorInstance.destroy();
  }
});

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
